import { AxiosResponse } from "axios";
import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { IBillingInvoice } from "../../../types/api/company";

export async function listBillingInvoices(): Promise<AxiosResponse<TResponse<IBillingInvoice[]>>> {
  return axios.get<TResponse<IBillingInvoice[]>>(API_ENDPOINTS.BILLING_INVOICES);
}

export async function getBillingInvoicePdf(
  id: number
): Promise<AxiosResponse<TResponse<{ pdf_url: string }>>> {
  return axios.get<TResponse<{ pdf_url: string }>>(API_ENDPOINTS.BILLING_INVOICE_PDF(id));
}
